module.exports = __webpack_public_path__ + "img/CreekRoadConsrvLocus_1.5492cb34.png";